import { TransactionOperatingSystemListItem } from '@/models/dictionary/transaction-operating-system-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface TransactionOperatingSystemListState {
  transactionOperatingSystemList: TransactionOperatingSystemListItem[];
  isTransactionOperatingSystemListLoading: boolean;
}

export const useTransactionOperatingSystemListStore = defineStore({
  id: 'TransactionOperatingSystemListStore',
  state: (): TransactionOperatingSystemListState => ({
    transactionOperatingSystemList: [],
    isTransactionOperatingSystemListLoading: false,
  }),
  actions: {
    setTransactionOperatingSystemListLoading(isLoading: boolean): void {
      this.isTransactionOperatingSystemListLoading = isLoading;
    },
    getTransactionOperatingSystemList(wlSlug: string): Promise<TransactionOperatingSystemListItem[] | void> {
      if (this.transactionOperatingSystemList.length > 0) {
        return Promise.resolve(this.transactionOperatingSystemList);
      }

      this.setTransactionOperatingSystemListLoading(true);

      return api.dictionary.getTransactionOperatingSystemListRequest.perform(wlSlug)
        .then((data) => {
          this.transactionOperatingSystemList = data;
        })
        .catch(error => {
          showErrorNotification(error);

          return Promise.reject(error);
        })
        .finally(() => {
          this.setTransactionOperatingSystemListLoading(false);
        });
    },
  },
});
